import {
    Box,
    Paper, Typography, useTheme,
    FormControl,
    Select,
    MenuItem,
    InputLabel,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { ptBR } from '@mui/x-data-grid/locales';
import clsx from 'clsx';
import React, { useEffect, useMemo, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { FerramentasDaListagem } from "../../shered/components";
import { useDebounce } from "../../shered/hooks";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { ILstDrop, UtilidadeService, tipoConfronto } from "../../shered/services/api/utilidades/UtilidadesService";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";

import { EstatisticasService, IDadosClassificacoesNBA, IDadosResumidoClassificacoesNBA, IListaDadosMediaTimes, IRetornoDadosClassificacaoNBA } from "../../shered/services/api/estatisticas/EstatisticasService";
import { DataGrid, GridCellParams, GridColDef } from "@mui/x-data-grid";
import { Loading } from "../../shered/components/loading/Loading";



const columnsClassificacaoGeral: GridColDef[] = [
    {
        field: 'codigo',
        headerName: '',
        flex: 1,
        minWidth: 58,
        maxWidth: 58,
        headerClassName: 'super-app-theme--header',
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'codigo_NBA',
        headerName: '',        
        minWidth: 58,
        maxWidth: 58,
        headerClassName: 'super-app-theme--header',
        align: 'center',
        headerAlign: 'center',

    },
    {
        field: 'posicao',
        headerName: '#',        
        minWidth: 50,
        maxWidth: 50,
        headerClassName: 'super-app-theme--header',
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'logo',
        headerName: 'LOGO',
        editable: false,
        minWidth: UtilidadeService.isMobile() ? 35 : 65,
        maxWidth: UtilidadeService.isMobile() ? 35 : 65,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => params.value !== null ? <img src={params.value} width={UtilidadeService.isMobile() ? 25 : 40} height={UtilidadeService.isMobile() ? 30 : 45} /> : null,
    },
    {
        field: 'nome',
        headerName: 'FRANQUIA',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 115 : 160,
        headerClassName: 'super-app-theme--header'
    },
    // {
    //     field: 'conferencia',
    //     headerName: 'CONFERÊNCIA',
    //     headerClassName: 'super-app-theme--header',
    //     flex: 1,
    //     sortable: false,
    //     minWidth: UtilidadeService.isMobile() ? 110 : 150,
    //     maxWidth: UtilidadeService.isMobile() ? 110 : 150,
    //     editable: false,
    //     align: 'center',
    //     headerAlign: 'center',

    // },
    // {
    //     field: 'jogos',
    //     headerName: 'JOGOS',
    //     headerClassName: 'super-app-theme--header',
    //     flex: 1,
    //     sortable: false,
    //     minWidth: UtilidadeService.isMobile() ? 110 : 130,
    //     maxWidth: UtilidadeService.isMobile() ? 110 : 130,
    //     editable: false,
    //     align: 'center',
    //     headerAlign: 'center'
    // },
    {
        field: 'minutos',
        headerName: 'MINUTOS',
        editable: false,
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 75 : 85,
        maxWidth: UtilidadeService.isMobile() ?  75 : 85,
        headerClassName: 'super-app-theme--header',
        align: 'center',
        headerAlign: 'center',
        //cellClassName: 'super-app-theme--cell',
        //renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    },
      {
        field: 'pontos',
        headerName: 'PTS',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 60,
        align: 'center',
        headerAlign: 'center',
        //cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.row.codigo_Tipo === 2 ? params.value.toFixed(2).replace(".", ",")  : params.value.toFixed(0).replace(".", ",") : "0"
    },
    {
        field: 'fgm',
        headerName: 'FGM',
        editable: false,
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: 60,
        maxWidth: 60,
        headerClassName: 'super-app-theme--header',
        align: 'center',
        headerAlign: 'center',
        // cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.row.codigo_Tipo === 2 ? params.value.toFixed(2).replace(".", ",")  : params.value.toFixed(0).replace(".", ",") : "0"
    },
    {
        field: 'fge',
        headerName: 'FGE',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 60,
        align: 'center',
        headerAlign: 'center',
       renderCell: (params) => params.value !== null ? params.row.codigo_Tipo === 2 ? params.value.toFixed(2).replace(".", ",")  : params.value.toFixed(0).replace(".", ",") : "0"
    },
    {
        field: 'fG_Tentativa',
        headerName: 'FGA',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 60,
        align: 'center',
        headerAlign: 'center',
         renderCell: (params) => params.value !== null ? params.row.codigo_Tipo === 2 ? params.value.toFixed(2).replace(".", ",")  : params.value.toFixed(0).replace(".", ",") : "0"
    },
    {
        field: 'fG_Porcentagem',
        headerName: 'FG%',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 60,
        align: 'center',
        headerAlign: 'center',
        //renderCell: (params) => params.value !== null && params.value !== undefined ? params.value.toFixed(2).replace(".", ",") : 0
    },
    {
        field: 'ftm',
        headerName: 'FTM',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 60,
        align: 'center',
        headerAlign: 'center',
         renderCell: (params) => params.value !== null ? params.row.codigo_Tipo === 2 ? params.value.toFixed(2).replace(".", ",")  : params.value.toFixed(0).replace(".", ",") : "0"
    },
    {
        field: 'fte',
        headerName: 'FTE',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 60,
        align: 'center',
        headerAlign: 'center',
         renderCell: (params) => params.value !== null ? params.row.codigo_Tipo === 2 ? params.value.toFixed(2).replace(".", ",")  : params.value.toFixed(0).replace(".", ",") : "0"
    },
    {
        field: 'fT_Tentativa',
        headerName: 'FTA',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 60,
        align: 'center',
        headerAlign: 'center',
         renderCell: (params) => params.value !== null ? params.row.codigo_Tipo === 2 ? params.value.toFixed(2).replace(".", ",")  : params.value.toFixed(0).replace(".", ",") : "0"
    },
    {
        field: 'fT_Porcentagem',
        headerName: 'FT%',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 60,
        align: 'center',
        headerAlign: 'center',
        //renderCell: (params) => params.value !== null && params.value !== undefined ? params.value.toFixed(2).replace(".", ",") : 0
    },     
    {
        field: 'dois_Pontos',
        headerName: '2P',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 60,
        align: 'center',
        headerAlign: 'center',
         renderCell: (params) => params.value !== null ? params.row.codigo_Tipo === 2 ? params.value.toFixed(2).replace(".", ",")  : params.value.toFixed(0).replace(".", ",") : "0"
    },
    {
        field: 'dois_Pontos_Errado',
        headerName: '2PE',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 60,
        align: 'center',
        headerAlign: 'center',
         renderCell: (params) => params.value !== null ? params.row.codigo_Tipo === 2 ? params.value.toFixed(2).replace(".", ",")  : params.value.toFixed(0).replace(".", ",") : "0"
    },
    {
        field: 'dois_Pontos_Tentativa',
        headerName: '2PA',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 60,
        align: 'center',
        headerAlign: 'center',
        renderCell: (params) => params.value !== null ? params.row.codigo_Tipo === 2 ? params.value.toFixed(2).replace(".", ",")  : params.value.toFixed(0).replace(".", ",") : "0"
    },
    {
        field: 'dois_Pontos_Porcentagem',
        headerName: '2P%',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 60,
        align: 'center',
        headerAlign: 'center',
        //renderCell: (params) => params.value !== null && params.value !== undefined ? params.value.toFixed(2).replace(".", ",") : 0
    },
    {
        field: 'tres_Pontos',
        headerName: '3P',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 60,
        align: 'center',
        headerAlign: 'center',
        renderCell: (params) => params.value !== null ? params.row.codigo_Tipo === 2 ? params.value.toFixed(2).replace(".", ",")  : params.value.toFixed(0).replace(".", ",") : "0"
    },
    {
        field: 'tres_Pontos_Errado',
        headerName: '3PE',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 60,
        align: 'center',
        headerAlign: 'center',
         renderCell: (params) => params.value !== null ? params.row.codigo_Tipo === 2 ? params.value.toFixed(2).replace(".", ",")  : params.value.toFixed(0).replace(".", ",") : "0"
    },
    {
        field: 'tres_Pontos_Tentativa',
        headerName: '3PA',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 60,
        align: 'center',
        headerAlign: 'center',
         renderCell: (params) => params.value !== null ? params.row.codigo_Tipo === 2 ? params.value.toFixed(2).replace(".", ",")  : params.value.toFixed(0).replace(".", ",") : "0"
    },
    {
        field: 'tres_Pontos_Porcentagem',
        headerName: '3P%',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 60,
        align: 'center',
        headerAlign: 'center',
        //renderCell: (params) => params.value !== null && params.value !== undefined ? params.value.toFixed(2).replace(".", ",") : 0
    },  
    {
        field: 'rebotes',
        headerName: 'REB',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 60,
        align: 'center',
        headerAlign: 'center',
        //cellClassName: 'super-app-theme--cell',
       renderCell: (params) => params.value !== null ? params.row.codigo_Tipo === 2 ? params.value.toFixed(2).replace(".", ",")  : params.value.toFixed(0).replace(".", ",") : "0"
    },
    {
        field: 'rebote_Ofensivo',
        headerName: 'OREB',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 60,
        align: 'center',
        headerAlign: 'center',
        //cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.row.codigo_Tipo === 2 ? params.value.toFixed(2).replace(".", ",")  : params.value.toFixed(0).replace(".", ",") : "0"
    },
    {
        field: 'rebote_Defensivo',
        headerName: 'DREB',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 60,
        align: 'center',
        headerAlign: 'center',
        // cellClassName: 'super-app-theme--cell',
         renderCell: (params) => params.value !== null ? params.row.codigo_Tipo === 2 ? params.value.toFixed(2).replace(".", ",")  : params.value.toFixed(0).replace(".", ",") : "0"
    },
    {
        field: 'assistencia',
        headerName: 'AST',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 60,
        align: 'center',
        headerAlign: 'center',
        // cellClassName: 'super-app-theme--cell',
         renderCell: (params) => params.value !== null ? params.row.codigo_Tipo === 2 ? params.value.toFixed(2).replace(".", ",")  : params.value.toFixed(0).replace(".", ",") : "0"
    },
    {
        field: 'steal',
        headerName: 'STL',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 60,
        align: 'center',
        headerAlign: 'center',
        // cellClassName: 'super-app-theme--cell',
         renderCell: (params) => params.value !== null ? params.row.codigo_Tipo === 2 ? params.value.toFixed(2).replace(".", ",")  : params.value.toFixed(0).replace(".", ",") : "0"
    },
    {
        field: 'bloqueio',
        headerName: 'BLK',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 60,
        align: 'center',
        headerAlign: 'center',
        //cellClassName: 'super-app-theme--cell',
         renderCell: (params) => params.value !== null ? params.row.codigo_Tipo === 2 ? params.value.toFixed(2).replace(".", ",")  : params.value.toFixed(0).replace(".", ",") : "0"
    },
    {
        field: 'turnovers',
        headerName: 'TOV',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 60,
        align: 'center',
        headerAlign: 'center',
        //cellClassName: 'super-app-theme--cell',
         renderCell: (params) => params.value !== null ? params.row.codigo_Tipo === 2 ? params.value.toFixed(2).replace(".", ",")  : params.value.toFixed(0).replace(".", ",") : "0"
    },
    {
        field: 'faltas',
        headerName: 'PF',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 60,
        align: 'center',
        headerAlign: 'center',
        //cellClassName: 'super-app-theme--cell',
         renderCell: (params) => params.value !== null ? params.row.codigo_Tipo === 2 ? params.value.toFixed(2).replace(".", ",")  : params.value.toFixed(0).replace(".", ",") : "0"
    },
    {
        field: 'stocks',
        headerName: 'STOCKS',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 80,
        maxWidth: UtilidadeService.isMobile() ? 50 : 80,
        align: 'center',
        headerAlign: 'center',
         renderCell: (params) => params.value !== null ? params.row.codigo_Tipo === 2 ? params.value.toFixed(2).replace(".", ",")  : params.value.toFixed(0).replace(".", ",") : "0"
    },
   
];

const columnsClassificacaoGeralResumido: GridColDef[] = [
    {
        field: 'codigo',
        headerName: '',
        flex: 1,
        minWidth: 58,
        maxWidth: 58,
        headerClassName: 'super-app-theme--header',
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'codigo_NBA',
        headerName: '',
        flex: 1,
        minWidth: 58,
        maxWidth: 58,
        headerClassName: 'super-app-theme--header',
        align: 'center',
        headerAlign: 'center',

    },
     {
        field: 'posicao',
        headerName: '#',
        flex: 1,
        minWidth: 50,
        maxWidth: 50,
        headerClassName: 'super-app-theme--header',
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'logo',
        headerName: 'LOGO',
        editable: false,
        flex: 1,
        minWidth: UtilidadeService.isMobile() ? 35 : 60,
        maxWidth: UtilidadeService.isMobile() ? 35 : 60,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => params.value !== null ? <img src={params.value} width={UtilidadeService.isMobile() ? 25 : 40} height={UtilidadeService.isMobile() ? 30 : 45} /> : null,
    },
    {
        field: 'nome',
        headerName: 'FRANQUIA',
        flex: 1,        
        minWidth: UtilidadeService.isMobile() ? 100 : 130,
        headerClassName: 'super-app-theme--header'
    },

    {
        field: 'conferencia',
        headerName: 'CONF.',
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable:false,
        minWidth: UtilidadeService.isMobile() ? 80 : 90,
        maxWidth: UtilidadeService.isMobile() ? 80 : 105,
        editable: false,
        align: 'center',
        headerAlign: 'center'
    },
    {
        field: 'jogos',
        headerName: 'JOGOS',
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 60 : 60,
        maxWidth: UtilidadeService.isMobile() ? 60 : 70,
        editable: false,
        align: 'center',
        headerAlign: 'center'
    }, {
        field: 'vitoria',
        headerName: 'VITÓRIA',
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: true,
        minWidth: UtilidadeService.isMobile() ? 60 : 60,
        maxWidth: UtilidadeService.isMobile() ? 60 : 70,
        editable: false,
        align: 'center',
        headerAlign: 'center'
    },
    {
        field: 'derrota',
        headerName: 'DERROTA',
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: true,
        minWidth: UtilidadeService.isMobile() ? 60 : 60,
        maxWidth: UtilidadeService.isMobile() ? 60 : 90,
        editable: false,
        align: 'center',
        headerAlign: 'center'
    },
    {
        field: 'aproveitamento',
        headerName: 'APROVEITAMENTO',
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: true,
        minWidth: UtilidadeService.isMobile() ? 70 : 80,
        maxWidth: UtilidadeService.isMobile() ? 70 : 150,
        editable: false,
        align: 'center',
        headerAlign: 'center'
    }
];

export const ListagemDeClassificacoesNBA: React.FC = () => {
    const theme = useTheme();
    //const refTab = useRef<any>(null);
    const { themeName } = useAppThemeContext();
    const { debounce } = useDebounce();
    const navigate = useNavigate();
    const { logout } = useAuthContext();
    //const user = CookieService.get("access_user");
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../semimagemescudo.png");
    //const [semImagem, setSemImagem] = useState<any>("../../../semimagem.png");
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [redirecionar, setRedirecionar] = useState("");
    const [searchParams, SetSearchParams] = useSearchParams();
    const [dadosRetorno, setDadosRetorno] = useState<IRetornoDadosClassificacaoNBA>();
    const [estatisticasLesteRows, setEstatisticasLesteRows] = useState<IDadosResumidoClassificacoesNBA[]>([]);
    const [estatisticasOesteRows, setEstatisticasOesteRows] = useState<IDadosResumidoClassificacoesNBA[]>([]);
    const [estatisticasStatsTimeRows, setEstatisticasStatsTimeRows] = useState<IDadosClassificacoesNBA[]>([]);
    const [estatisticasStatsTotalRows, setEstatisticasStatsTotalRows] = useState<IDadosClassificacoesNBA[]>([]);

    const [temporadaFiltro, setTemporadaFiltro] = useState(0);
    const [tipoConfrontoFiltro, setTipoConfrontoFiltro] = useState(1);
    const [qtdRodadasFiltro, setQtdRodadasFiltro] = useState(5);
    const [isLoading, setIsLoading] = useState(true);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ronovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    });


    useEffect(() => {
        setIsLoading(true);
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar("/dashboard");
            return;
        } else {
            debounce(() => {
                UtilidadeService.getTemporadasLiga(Number(codigoLiga))
                    .then((result) => {
                        const tmps = result.data.dado;
                        let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
                        setLstTemporadas(lstTemporadasAux);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        if (errors.response !== undefined) {
                            if (errors.response.status === 401) {
                                setDadosModalMensagem({
                                    acao: true,
                                    label: "",
                                    tipo: "info",
                                    mensagem: "Sessão expirada!",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                logout();
                                setRedirecionar("0");
                                return;
                            }
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: errors.response.data.mensagem,
                                display: "none",
                                titulo: "Atenção"
                            });
                            return;
                        }

                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados. Tente novamente mais tarde. Caso o problema persista, favor entrar em contato com a TI.",
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;

                    });

                LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                    .then((result) => {
                        const liga = result.dado;
                        setDadosLiga(liga);
                        if (liga.caminho_Logo !== null) {
                            setShowImagemFranquia(liga.caminho_Logo);
                        }
                        setTemporadaFiltro(liga.codigo_Temporada);
                        carregarDadosTimes(liga.codigo_Temporada);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        setRemoveLoading(true);
                        if (errors.response !== undefined) {
                            if (errors.response.status === 401) {
                                setDadosModalMensagem({
                                    acao: true,
                                    label: "",
                                    tipo: "info",
                                    mensagem: "Sessão expirada!",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                logout();
                                setRedirecionar("0");
                                return;
                            }

                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: errors.response.data.mensagem,
                                display: "none",
                                titulo: "Atenção"
                            });
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados. Tente novamente mais tarde. Caso o problema persista, favor entrar em contato com a TI.",
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar("0");
                        return;
                    });
            })
        }
    }, []);

    const carregarDadosTimes = (codigoTemporada: number) => {
        setIsLoading(true);
        setRemoveLoading(false);

        EstatisticasService.getClassificacoesNBA(codigoTemporada)
            .then((result) => {
                const objDados = result.dado;
                if (objDados !== null && objDados !== undefined) {
                    setDadosRetorno(objDados);
                    setEstatisticasLesteRows(objDados.classificacao_Conferencia.conferencia_Leste);
                    setEstatisticasOesteRows(objDados.classificacao_Conferencia.conferencia_Oeste);
                    setEstatisticasStatsTimeRows(objDados.classificacao_Stats.jogo);
                    setEstatisticasStatsTotalRows(objDados.classificacao_Stats.total);
                }
                setIsLoading(false);
                setRemoveLoading(true);
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }

                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados! Tente novamente mais tarde e caso o problema persista, favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });

                setRedirecionar(`/usuario/liga/${codLocal}`);
                return;
            });
    }

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
        }
    };

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
        }
    }

    const handleSelectedTemporada = async (e: { target: { name: string; value: any; }; }) => {
        setTemporadaFiltro(e.target.value);
        setEstatisticasLesteRows([]);
        setEstatisticasOesteRows([]);
        setEstatisticasStatsTimeRows([]);
        setEstatisticasStatsTotalRows([]);
        if (Number(e.target.value) > 0) {
            carregarDadosTimes(Number(e.target.value));
        }
    }


    return (
        <LayoutBaseDePagina
            titulo={`Classificações NBA`}
            showLogoImg={showImagemFranquia}
            barraDeFerramentas={<FerramentasDaListagem
                textoBotaoNovo="Nova"
                mostrarBotaoNovo={false}
                mostrarInputBusca={false}
                aoMudarTextoDeBusca={texto => SetSearchParams({ busca: texto, pagina: "1" }, { replace: true })}
            />}>

            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <Box margin={1} display="flex" component={Paper} variant="outlined"  >
                <Grid container size={{ xs: 12, sm: 12 }} sx={{ width: "100%" }}>
                    <Grid container size={{ xs: 12, sm: 12 }} direction="column" padding={2} spacing={2} >
                        <Grid container size={{ xs: 12, sm: 12 }} spacing={1}>
                            <Grid size={{ xs: 12, sm: 12 }} >
                                <Typography variant="h6"> Classificações NBA </Typography>
                                <hr />
                            </Grid>
                            <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="initial" spacing={2}>
                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                    <FormControl fullWidth disabled={isLoading}>
                                        <InputLabel id="demo-simple-select-label">Temporadas</InputLabel>
                                        <Select
                                            variant="outlined"
                                            native={false}
                                            value={temporadaFiltro}
                                            label="Temporadas"
                                            onChange={(handleSelectedTemporada)}
                                        >
                                            <MenuItem value={0}>Selecione</MenuItem>
                                            {
                                                lstTemporadas.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                            }

                                        </Select>
                                    </FormControl >
                                </Grid>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}>
                                {isLoading && !removeLoading && <Loading />}
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }} >
                                <Typography variant="h6"> Conferencias </Typography>
                                <hr />
                            </Grid>
                            <Grid container size={{ xs: 12, sm: 12 }} style={{ width: "100%" }} >
                                <Grid size={{ xs: 12, sm: 6 }} padding={0} >
                                    {estatisticasLesteRows.length > 0 && (
                                        <Box sx={{
                                            width: "100%",
                                            height: 'auto', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                            '& .super-app-theme--header': {
                                                backgroundColor: theme.palette.common.black,
                                                color: theme.palette.common.white,
                                                //position: "fixed"
                                            },
                                            '& .super-app.negative': {
                                                color: 'red',
                                                fontWeight: 'bold'
                                            },
                                            '& .super-app.positive': {
                                                color: "#00e676", /// themeName === "light" ? "black" : "auto",
                                                fontWeight: '600',
                                            },
                                            '& .super-app-theme--cell': {
                                                color: '#00e676',
                                                fontWeight: '600',
                                            },
                                            '& .MuiDataGrid-main': {
                                                height: UtilidadeService.isMobile() ? "280px" : "maxValor",
                                                overflow: UtilidadeService.isMobile() ? "overlay" : "hidden",
                                            },
                                            '& .MuiDataGrid-columnHeaders ': {
                                                //position: UtilidadeService.isMobile() ? "fixed" : "relative",
                                                zIndex: UtilidadeService.isMobile() ? 999 : "auto",
                                            }
                                        }}>
                                            <DataGrid
                                                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                getRowId={(r) => r.codigo}
                                                rows={estatisticasLesteRows}
                                                columns={columnsClassificacaoGeralResumido}
                                                initialState={{
                                                    pagination: {
                                                        paginationModel: {
                                                            pageSize: 50,
                                                        },
                                                    },
                                                }}
                                                columnVisibilityModel={{
                                                    codigo: false,
                                                    codigo_NBA: false
                                                }}
                                                  rowHeight={42}
                                            columnHeaderHeight={37} 
                                                disableDensitySelector
                                                disableVirtualization
                                                disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                                pageSizeOptions={[50]}
                                                disableRowSelectionOnClick
                                                sx={{
                                                    fontSize: UtilidadeService.isMobile() ? 11 : 13,
                                                }}

                                            />
                                        </Box>
                                    )}

                                </Grid>                              
                                <Grid size={{ xs: 12, sm: 6 }} padding={0} >
                                    {estatisticasOesteRows.length > 0 && (
                                        <Box sx={{
                                            width: "100%",
                                            height: 'auto', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                            '& .super-app-theme--header': {
                                                backgroundColor: theme.palette.common.black,
                                                color: theme.palette.common.white,
                                                //position: "fixed"
                                            },
                                            '& .super-app.negative': {
                                                color: 'red',
                                                fontWeight: 'bold'
                                            },
                                            '& .super-app.positive': {
                                                color: "#00e676", /// themeName === "light" ? "black" : "auto",
                                                fontWeight: '600',
                                            },
                                            '& .super-app-theme--cell': {
                                                color: '#00e676',
                                                fontWeight: '600',
                                            },
                                            '& .MuiDataGrid-main': {
                                                height: UtilidadeService.isMobile() ? "280px" : "maxValor",
                                                overflow: UtilidadeService.isMobile() ? "overlay" : "hidden",
                                            },
                                            '& .MuiDataGrid-columnHeaders ': {
                                                //position: UtilidadeService.isMobile() ? "fixed" : "relative",
                                                zIndex: UtilidadeService.isMobile() ? 999 : "auto",
                                            }
                                        }}>
                                            <DataGrid
                                                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                getRowId={(r) => r.codigo}
                                                rows={estatisticasOesteRows}
                                                columns={columnsClassificacaoGeralResumido}
                                                initialState={{
                                                    pagination: {
                                                        paginationModel: {
                                                            pageSize: 50,
                                                        },
                                                    },
                                                }}
                                                columnVisibilityModel={{
                                                    codigo: false,
                                                    codigo_NBA: false
                                                }}
                                                  rowHeight={42}
                                            columnHeaderHeight={37} 
                                                disableDensitySelector
                                                disableVirtualization
                                                disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                                pageSizeOptions={[50]}
                                                disableRowSelectionOnClick
                                                sx={{
                                                    fontSize: UtilidadeService.isMobile() ? 11 : 13,
                                                }}

                                            />
                                        </Box>
                                    )}

                                </Grid>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }} paddingTop={2}>
                                <Typography variant="h6"> Stats de Times Por Jogo </Typography>
                                <hr />
                            </Grid>
                            <Grid container size={{ xs: 12, sm: 12 }} style={{ width: "100%" }} paddingTop={2}>
                                {estatisticasStatsTimeRows.length > 0 && (
                                    <Box sx={{
                                        width: "100%",
                                        height: 'auto', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                        '& .super-app-theme--header': {
                                            backgroundColor: theme.palette.common.black,
                                            color: theme.palette.common.white,
                                            //position: "fixed"
                                        },
                                        '& .super-app.negative': {
                                            color: 'red',
                                            fontWeight: 'bold'
                                        },
                                        '& .super-app.positive': {
                                            color: "#00e676", /// themeName === "light" ? "black" : "auto",
                                            fontWeight: '600',
                                        },
                                        '& .super-app-theme--cell': {
                                            color: '#00e676',
                                            fontWeight: '600',
                                        },
                                        '& .MuiDataGrid-main': {
                                            height: UtilidadeService.isMobile() ? "280px" : "maxValor",
                                            overflow: UtilidadeService.isMobile() ? "overlay" : "hidden",
                                        },
                                        '& .MuiDataGrid-columnHeaders ': {
                                            //position: UtilidadeService.isMobile() ? "fixed" : "relative",
                                            zIndex: UtilidadeService.isMobile() ? 999 : "auto",
                                        }
                                    }}>
                                        <DataGrid
                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                            getRowId={(r) => r.codigo}
                                            rows={estatisticasStatsTimeRows}
                                            columns={columnsClassificacaoGeral}
                                            rowHeight={40}
                                            columnHeaderHeight={32} 
                                            initialState={{
                                                pagination: {
                                                    paginationModel: {
                                                        pageSize: 15,
                                                    },
                                                },
                                            }}
                                            columnVisibilityModel={{
                                                codigo: false,
                                                codigo_NBA: false
                                            }}
                                            disableDensitySelector
                                            disableVirtualization
                                            disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                            pageSizeOptions={[15, 30, 50]}
                                            disableRowSelectionOnClick
                                            sx={{
                                                fontSize: UtilidadeService.isMobile() ? 11 : 13,
                                            }}

                                        />
                                    </Box>
                                )}
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}  paddingTop={2}>
                                <Typography variant="h6"> Stats Total </Typography>
                                <hr />
                            </Grid>
                            <Grid container size={{ xs: 12, sm: 12 }} style={{ width: "100%" }}  paddingTop={2}>
                                {estatisticasStatsTotalRows.length > 0 && (
                                    <Box sx={{
                                        width: "100%",
                                        height: 'auto', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                        '& .super-app-theme--header': {
                                            backgroundColor: theme.palette.common.black,
                                            color: theme.palette.common.white,
                                            //position: "fixed"
                                        },
                                        '& .super-app.negative': {
                                            color: 'red',
                                            fontWeight: 'bold'
                                        },
                                        '& .super-app.positive': {
                                            color: "#00e676", /// themeName === "light" ? "black" : "auto",
                                            fontWeight: '600',
                                        },
                                        '& .super-app-theme--cell': {
                                            color: '#00e676',
                                            fontWeight: '600',
                                        },
                                        '& .MuiDataGrid-main': {
                                            height: UtilidadeService.isMobile() ? "280px" : "maxValor",
                                            overflow: UtilidadeService.isMobile() ? "overlay" : "hidden",
                                        },
                                        '& .MuiDataGrid-columnHeaders ': {
                                            //position: UtilidadeService.isMobile() ? "fixed" : "relative",
                                            zIndex: UtilidadeService.isMobile() ? 999 : "auto",
                                        }
                                    }}>
                                        <DataGrid
                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                            getRowId={(r) => r.codigo}
                                            rows={estatisticasStatsTotalRows}
                                            columns={columnsClassificacaoGeral}
                                            initialState={{
                                                pagination: {
                                                    paginationModel: {
                                                        pageSize: 15,
                                                    },
                                                },
                                            }}
                                           
                                            columnVisibilityModel={{
                                                codigo: false,
                                                codigo_NBA: false
                                            }}
                                            
                                            disableDensitySelector
                                            disableVirtualization
                                            disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                            pageSizeOptions={[15, 30, 50]}
                                            disableRowSelectionOnClick
                                               rowHeight={40}
                                            columnHeaderHeight={32} 
                                            sx={{
                                                fontSize: UtilidadeService.isMobile() ? 11 : 13,
                                            }}

                                        />
                                    </Box>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </LayoutBaseDePagina>
    )
}


